export class WeekDays {
    constructor(checkboxes, error) {
        this.checkboxes = checkboxes;
        this.error = error;
    }
    static create(form) {
        const checkboxes = form.querySelectorAll(".js-week-day");
        if (checkboxes.length > 0) {
            const error = form.querySelector(".js-days").dataset.daysError;
            return new WeekDays(checkboxes, error ?? "You must select at least one day");
        }
        return null;
    }
    validate() {
        for (const checkbox of this.checkboxes) {
            if (checkbox.checked) {
                return null;
            }
        }
        return this.error;
    }
}
